import {_Staff as Staff} from "./_Staff";
import {_TimeoffRequests as TimeoffRequests} from "./_TimeoffRequests";
import {_LeaveRequests as LeaveRequests} from "./_LeaveRequests";

export const ModuloHRAPI = {
    Staff: Staff,
    TimeoffRequests: TimeoffRequests,
    LeaveRequests: LeaveRequests
};
